import type { CompletionResult } from '@codemirror/autocomplete';
import { CompletionContext } from '@codemirror/autocomplete';

import { listAutocompletion } from './list-autocompletion.js';
import type { IntlProps } from '../../utils/render-node.js';
import type { Suggestion } from '../autocompletion.extension.js';
import { autocompletionExtension } from '../autocompletion.extension.js';

/**
 * @internal
 */
export interface ListAutocompletionConfig {
  /** Regex that needs to match before in order to trigger the auto-completions */
  readonly matchBefore: RegExp;

  /** Auto-completions that are shown after the `matchBefore` RegExp was found. */
  autocompletionList: (() => Promise<Suggestion[]>) | Suggestion[];

  reopen?: boolean;
}

export const listAutocompletionExtension = (
  listAutoCompletionConfig: ListAutocompletionConfig,
  intlProps: IntlProps,
): ((ctx: CompletionContext) => Promise<CompletionResult | null>) => {
  return autocompletionExtension(
    listAutocompletion(listAutoCompletionConfig),
    intlProps,
  );
};
